<template>
    <common-layout>
        <div class="LearningRecord">
            <div class="header">
                <span class="txt">学习记录</span>
                <div>
                    <el-select v-model="year" @change="handleChange" size="small" placeholder="请选择">
                        <el-option
                            v-for="item in columns"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="cursor_list" v-loading="loading">
                <el-empty style="width:100%;" v-if="archivesItem.length==0" description="暂无已学课程列表"></el-empty>
                <learning-details :d-height="dHeight" class="cursor_item" v-for="(item,index) in archivesItem" :key="index" :cursorDetail="item" v-on="$listeners" @setEqual="getEqual"></learning-details>
            </div>
        </div>
    </common-layout>
</template>
<script>
import { studyProfile } from '@/api/user'
import CommonLayout from '@/components/LearningCenterComponents/Common'
import LearningDetails from "@/components/LearningDetails"
export default {
    components:{
        CommonLayout,
        LearningDetails
    },
    data(){
        return {
            year:'',
            columns:'',
            archivesItem:[],
            loading:false,
            dHeight:0
        }
    },
    created(){
        this.year = new Date().getFullYear()
        this.columns = [this.year,this.year-1,this.year-2]
        this.getStudyProfile(this.year)
    },
    methods:{
        getStudyProfile(year){
            this.loading = true
            studyProfile({year}).then(res=>{
                this.loading = false
                this.archivesItem = res.data.map(v=>{
                    return {...v,endTimeS:v.endTime.split(' ')[0]}
                })
            }).catch(()=>{
                this.loading = false
            })
        },
        handleChange(val){
            this.getStudyProfile(val)
        },
        getEqual(h){
            this.dHeight = (this.dHeight<h?h:this.dHeight)
        }
    }
}
</script>
<style lang="scss" scoped>
.LearningRecord{
    padding:30px;
}
.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .txt{
        font-size: 20px;
        font-weight: bold;
        color: #3964E6;
    }
}
.cursor_list{
    display: flex;
    flex-wrap: wrap;
    .cursor_item{
        width: 50%;
    }
}
</style>